"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useInnerCoordinates_1 = __importDefault(require("../../../projection/useInnerCoordinates"));
const tech_1 = require("../../../../tech");
const Config_1 = require("../../../../tech/Config");
function useLauPolygon() {
    const url = (0, Config_1.getConfigValue)('COMMON_API_BASE_PATH') + "/map/fce/select.php";
    const convert = (0, useInnerCoordinates_1.default)();
    const parse = (data) => {
        let poly = "[";
        const polyArray = data.split("@");
        const resultArray = [];
        let i = 1;
        while (i < polyArray.length) {
            const coorArray = polyArray[i].split("/");
            poly = poly + "[";
            const onePolygon = [];
            let index = 1;
            while (index < coorArray.length) {
                const coor = coorArray[index];
                const xy = coor.split(",");
                const x = Number(xy[0]);
                const y = Number(xy[1]);
                const ret = [x, y]; //epsgToWgs(x, y)
                const converted = convert(ret);
                onePolygon.push(converted);
                var obj_y = (ret[0]);
                var obj_x = (ret[1]);
                poly = poly + "[" + obj_x + "," + obj_y + "]";
                if (index < (coorArray.length - 1)) {
                    poly = poly + ",";
                }
                index++;
            }
            poly = poly + "]";
            resultArray.push(onePolygon);
            if (i < (polyArray.length - 1)) {
                poly = poly + ",";
            }
            i++;
        }
        poly = poly + "]";
        return resultArray;
    };
    const get = async (lau) => {
        const requestResult = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: (0, tech_1.toFormString)({
                "method": "polyObce",
                "submethod": `map`,
                "lau": lau + ""
            })
        });
        const result = await requestResult.text();
        if (result === "")
            console.error("Fetching lau polygon failed");
        return parse(result);
    };
    return get;
}
exports.default = useLauPolygon;
